import { IIdentifiable } from '@/common/models/models'

interface ICategory extends IIdentifiable {
    category: string
    main_menu: boolean
    entries_per_page: number
    position: number
    image: string
    slug: string
}

class Category implements ICategory {
    id = 0
    // Space instead of empty string, because it is used for breadcrumb title, which is then used
    // in the HeaderBreadcrumbs components as a key
    category = ' '
    main_menu = false
    entries_per_page = 6
    position = 0
    image = ''
    slug = '-'

    file: File | null = null

    constructor (dto?: ICategory) {
        if (dto) {
            this.id = dto.id
            this.category = dto.category
            this.main_menu = dto.main_menu
            this.entries_per_page = dto.entries_per_page
            this.position = dto.position
            this.image = dto.image
            this.slug = dto.slug
        }
    }
}

export {
    ICategory, Category
}
